import { atom } from 'recoil';

export const noticeCurrentPage = atom({
  key: 'noticeCurrentPage',
  default: 1,
});
